module.exports = __webpack_public_path__ + "img/height-weight.6df273a7.jpg";